"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetLeakDetectionData = void 0;
const react_1 = require("react");
const HumidityThresholds_1 = require("../types/water/HumidityThresholds");
const LeakDetection_1 = require("../types/water/LeakDetection");
const useGetLeakDetectionData = ({ humidity, leakDetected, timestamp, }) => {
    const status = (0, react_1.useMemo)(() => {
        if (leakDetected)
            return LeakDetection_1.LeakThreshold.LeakDetected;
        if (humidity === null)
            return LeakDetection_1.LeakThreshold.InvalidData;
        if ((0, HumidityThresholds_1.isHumidityHigh)(humidity))
            return LeakDetection_1.LeakThreshold.ExtremelyHumid;
        if ((0, HumidityThresholds_1.isHumidityElevated)(humidity))
            return LeakDetection_1.LeakThreshold.HighHumidity;
        if (humidity <= 40)
            return LeakDetection_1.LeakThreshold.SlightlyHumid; // Low/Dry
        return LeakDetection_1.LeakThreshold.NoLeak; // 41-60 = Good/Normal
    }, [humidity, leakDetected]);
    const gradientColors = (0, react_1.useMemo)(() => {
        switch (status) {
            case LeakDetection_1.LeakThreshold.LeakDetected:
                return [LeakDetection_1.LeakColor.Red, LeakDetection_1.LeakColor.Red, LeakDetection_1.LeakColor.Red];
            case LeakDetection_1.LeakThreshold.ExtremelyHumid:
            case LeakDetection_1.LeakThreshold.HighHumidity:
                return [LeakDetection_1.LeakColor.Red, LeakDetection_1.LeakColor.Red, LeakDetection_1.LeakColor.Red];
            case LeakDetection_1.LeakThreshold.SlightlyHumid:
                return [LeakDetection_1.LeakColor.Yellow, LeakDetection_1.LeakColor.Yellow, LeakDetection_1.LeakColor.Yellow];
            case LeakDetection_1.LeakThreshold.NoLeak:
                return [LeakDetection_1.LeakColor.Green, LeakDetection_1.LeakColor.Green, LeakDetection_1.LeakColor.Green];
            default:
                return [LeakDetection_1.LeakColor.Green, LeakDetection_1.LeakColor.Green, LeakDetection_1.LeakColor.Green];
        }
    }, [status]);
    return {
        status,
        leakDetected: status === LeakDetection_1.LeakThreshold.LeakDetected,
        gradientColors,
        timestamp,
        humidity,
    };
};
exports.useGetLeakDetectionData = useGetLeakDetectionData;
